import { useCallback, useMemo } from 'react';
import { scrollServiceRegistry } from '../../../services/extended-scroll.service';

export const useSaveScroll = (key: string) => {
    const scrollService = useMemo(() => scrollServiceRegistry.getService(key), [key]);

    const saveScroll = useCallback(() => {
        scrollService.saveScrollTop();
    }, [scrollService]);

    const restoreScroll = useCallback(() => {
        scrollService.restoreScrollY();
    }, [scrollService]);

    const saveScrollIfPresent = useCallback(() => {
        const scrollYPosition = document.scrollingElement?.scrollTop
            || document.documentElement.scrollTop;
        if (scrollYPosition) {
            scrollService.saveScrollTop(scrollYPosition);
        }
    }, [scrollService]);

    return {
        saveScroll,
        restoreScroll,
        saveScrollIfPresent
    };
};
